import { render, staticRenderFns } from "./Esg5.vue?vue&type=template&id=67383256&scoped=true"
import script from "./Esg5.vue?vue&type=script&lang=js"
export * from "./Esg5.vue?vue&type=script&lang=js"
import style0 from "./Esg5.vue?vue&type=style&index=0&id=67383256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67383256",
  null
  
)

export default component.exports